// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"98":"component---src-pages-thanks-js","125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"98":"853472e61998bfe52893","125":"81bf33166d23ac8c6ca5","293":"e07a322aa79e1ee997b8","452":"9259da7be920ea6be672","896":"4cd34dc0089fd6a5d100"}[chunkId] + ".js";
};